<osp-stepper [formGroup]="form">
  <!-- STEP #1 -->
  @if (!isEditMode) {
    <osp-step
      [title]="'modules.notification.base.alarmType' | translate"
      [control]="alarmTypeControl"
      [icon]="IconKey.NotificationsFormAlarmType | icon"
    >
      <ng-template ospStepContent>
        <div class="step-content">
          <osp-alarm-type-selection
            [options]="allowedAlarmTypes"
            [alarmTypeControl]="alarmTypeControl"
            (onAlarmTypeChange)="handleAlarmTypeChange($event)"
          />
        </div>
      </ng-template>
      <ng-template ospStepFooter let-nextCallback="nextCallback" let-isValid="isValid" #footer>
        <div class="step-footer">
          <osp-button [category]="'ghost'" [label]="'general.buttons.cancel' | translate" (onClick)="closeDialog()" />
          <osp-button [label]="'general.buttons.next' | translate" (onClick)="nextCallback()" [disabled]="!isValid" />
        </div>
      </ng-template>
    </osp-step>
  }

  <!-- STEP #2 -->
  <osp-step
    [title]="'modules.notification.alarmRuleAddEdit.alarmDetail' | translate"
    [control]="form"
    [icon]="IconKey.NotificationsFormAlarmDetails | icon"
  >
    <ng-template ospStepContent>
      <div class="step-content">
        <div class="step-content__inner-container">
          <div class="step-content__form-container alarm-settings-form">
            @switch ($currentSettingsType()) {
              @case (settingsTypes.LIMIT) {
                <ng-container [ngTemplateOutlet]="alarmSettingHeaderTemplate"></ng-container>
                <osp-limit-settings [form]="settingsForm" [fieldData]="alarmSettingsFieldData" />
              }
              @case (settingsTypes.LIMIT_PERCENTAGE) {
                <ng-container [ngTemplateOutlet]="alarmSettingHeaderTemplate"></ng-container>
                <osp-limit-percentage-settings [form]="settingsForm" [fieldData]="alarmSettingsFieldData" />
              }
              @case (settingsTypes.GEOFENCE) {
                <ng-container [ngTemplateOutlet]="alarmSettingHeaderTemplate"></ng-container>
                <osp-geofence-settings
                  [form]="settingsForm"
                  [fieldData]="alarmSettingsFieldData"
                  [globalGeofences]="globalGeofences"
                />
              }
              @case (settingsTypes.TIMEFENCING) {
                <ng-container [ngTemplateOutlet]="alarmSettingHeaderTemplate"></ng-container>
                <osp-timefencing-settings [form]="settingsForm" [fieldData]="alarmSettingsFieldData" />
              }
              @case (settingsTypes.TRACKER_BATTERY_STATUS) {
                <ng-container [ngTemplateOutlet]="alarmSettingHeaderTemplate"></ng-container>
                <osp-tracker-battery-alarm-status [form]="settingsForm" [fieldData]="alarmSettingsFieldData" />
              }
              @case (settingsTypes.TELEMATICS_UNIT) {
                <ng-container [ngTemplateOutlet]="alarmSettingHeaderTemplate"></ng-container>
                <osp-inactive-telematic-unit-settings [form]="settingsForm" [fieldData]="alarmSettingsFieldData" />
              }
            }

            <ng-template #alarmSettingHeaderTemplate>
              <p class="font-bold text-lg mt-0">
                {{ 'modules.notification.alarmRuleAddEdit.alarmTrigger' | translate }}
              </p>
            </ng-template>
          </div>

          <osp-additional-data
            [alarmType]="alarmTypeControl?.value"
            [form]="dataForm"
            [labelOptions]="labels"
            [equipmentTypeOptions]="$equipmentTypes()"
            [equipmentOptions]="equipmentOptionLoader.$options()"
            [customerOptions]="customerOptionLoader.$options()"
            [emailRecipients]="this.alarm?.emailRecipientsFilledWithInfo ?? []"
            [defaultEmailRecipients]="buildDefaultRecipientsForAlarm()"
            [roleRecipients]="this.alarm?.userRolesEmailRecipientsFilledWithInfo ?? []"
            [equipmentsLoading]="equipmentOptionLoader.$loading()"
            [customersLoading]="customerOptionLoader.$loading()"
            [alarmTypeConfigs]="alarmTypeConfigs"
            [isAllowedToSeeDefaultRecipients]="allowedToSeeDefaultAlarms()"
            (onEquipmentFilter)="equipmentOptionLoader.searchChange($event)"
            (onCustomerFilter)="customerOptionLoader.load($event)"
          />
        </div>
        <div class="step-content__card-container">
          <osp-card-option
            [icon]="alarmSettingsUtilsService.alarmType | alarmTypeIcon"
            [label]="alarmSettingsUtilsService.alarmType | alarmTypeDisplay"
            [description]="alarmSettingsUtilsService.alarmType | alarmTypeDescription"
          />
        </div>
      </div>
    </ng-template>
    <ng-template ospStepFooter let-prevCallback="prevCallback" let-isValid="isValid">
      <div class="step-footer">
        <osp-button [category]="'ghost'" [label]="'general.buttons.cancel' | translate" (onClick)="closeDialog()" />
        <div class="button-group">
          @if (!isEditMode) {
            <osp-button
              [category]="'secondary'"
              [label]="'general.buttons.back' | translate"
              (onClick)="prevCallback()"
              [disabled]="$isSubmittingForm()"
            />
          }
          <osp-button
            [label]="'general.buttons.save' | translate"
            (onClick)="handleSubmission()"
            [disabled]="!isValid"
            [loading]="$isSubmittingForm()"
          />
        </div>
      </div>
    </ng-template>
  </osp-step>
</osp-stepper>
